import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Table, Badge, ProgressBar, Alert, Button, Spinner } from "react-bootstrap";
import { FaHotel, FaSync, FaBed, FaInfoCircle, FaArrowLeft, FaDownload } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import asignacionCamasTrabajadoresApi from "../../../services/api/asignacionCamasTrabajadoresApi";

const EstadoCampamento = () => {
  const navigate = useNavigate();
  const [estado, setEstado] = useState({
    loading: false,
    data: null,
  });
  const [descargando, setDescargando] = useState({
    ocupadas: false,
    reservadas: false,
    libres: false,
  });

  const loadEstado = async () => {
    setEstado((prev) => ({ ...prev, loading: true }));
    try {
      const response = await asignacionCamasTrabajadoresApi.getEstadoCampamento();
      if (response.data?.success) {
        setEstado({ loading: false, data: response.data });
      } else {
        toast.error(response.data?.message || "Error al obtener estado del campamento");
        setEstado({ loading: false, data: null });
      }
    } catch (error) {
      console.error("Error al obtener estado del campamento:", error);
      toast.error(error.response?.data?.detail || "Error al obtener estado del campamento");
      setEstado({ loading: false, data: null });
    }
  };

  useEffect(() => {
    loadEstado();
  }, []);

  const descargarReporteOcupadas = async () => {
    setDescargando(prev => ({ ...prev, ocupadas: true }));
    try {
      const response = await asignacionCamasTrabajadoresApi.getDetalleOcupadas();
      if (response.data?.success && response.data.data) {
        const data = response.data.data.map(item => ({
          'Zona': item.zona_nombre,
          'Módulo': item.modulo_nombre,
          'Habitación': item.habitacion_numero,
          'Cama': item.cama_codigo,
          'DNI': item.trabajador_documento,
          'Trabajador': item.trabajador_nombre,
          'Fecha Check-in': item.fecha_check_in,
          'Observaciones': item.observaciones || ''
        }));
        
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Camas Ocupadas");
        XLSX.writeFile(wb, `Camas_Ocupadas_${new Date().toISOString().split('T')[0]}.xlsx`);
        toast.success(`✅ Reporte descargado: ${data.length} camas ocupadas`);
      } else {
        toast.warning("No hay camas ocupadas para exportar");
      }
    } catch (error) {
      console.error("Error al descargar reporte de ocupadas:", error);
      toast.error("Error al descargar reporte de camas ocupadas");
    } finally {
      setDescargando(prev => ({ ...prev, ocupadas: false }));
    }
  };

  const descargarReporteReservadas = async () => {
    setDescargando(prev => ({ ...prev, reservadas: true }));
    try {
      const response = await asignacionCamasTrabajadoresApi.getDetalleReservadas();
      if (response.data?.success && response.data.data) {
        const data = response.data.data.map(item => ({
          'Zona': item.zona_nombre,
          'Módulo': item.modulo_nombre,
          'Habitación': item.habitacion_numero,
          'Cama': item.cama_codigo,
          'DNI': item.trabajador_documento,
          'Trabajador': item.trabajador_nombre,
          'Fecha Reserva': item.fecha_reserva,
          'Observaciones': item.observaciones || ''
        }));
        
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Camas Reservadas");
        XLSX.writeFile(wb, `Camas_Reservadas_${new Date().toISOString().split('T')[0]}.xlsx`);
        toast.success(`✅ Reporte descargado: ${data.length} camas reservadas`);
      } else {
        toast.warning("No hay camas reservadas para exportar");
      }
    } catch (error) {
      console.error("Error al descargar reporte de reservadas:", error);
      toast.error("Error al descargar reporte de camas reservadas");
    } finally {
      setDescargando(prev => ({ ...prev, reservadas: false }));
    }
  };

  const descargarReporteLibres = async () => {
    setDescargando(prev => ({ ...prev, libres: true }));
    try {
      const response = await asignacionCamasTrabajadoresApi.getDetalleLibres();
      if (response.data?.success && response.data.data) {
        const data = response.data.data.map(item => ({
          'Zona': item.zona_nombre,
          'Módulo': item.modulo_nombre,
          'Habitación': item.habitacion_numero,
          'Cama': item.cama_codigo,
          'Tipo Habitación': item.tipo_habitacion,
          'Estado': item.estado_cama
        }));
        
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Camas Libres");
        XLSX.writeFile(wb, `Camas_Libres_${new Date().toISOString().split('T')[0]}.xlsx`);
        toast.success(`✅ Reporte descargado: ${data.length} camas libres`);
      } else {
        toast.warning("No hay camas libres para exportar");
      }
    } catch (error) {
      console.error("Error al descargar reporte de libres:", error);
      toast.error("Error al descargar reporte de camas libres");
    } finally {
      setDescargando(prev => ({ ...prev, libres: false }));
    }
  };

  const totalCamas = estado.data?.resumen_global?.total_camas || 0;
  const totalOcupadas = estado.data?.resumen_global?.camas_ocupadas || 0;
  const totalReservadas = estado.data?.resumen_global?.camas_reservadas || 0;
  const totalLibres = estado.data?.resumen_global?.camas_libres || 0;
  const totalNoDisponibles = estado.data?.resumen_global?.camas_no_disponibles || 0;
  const porcentajeOcupacionGlobal = estado.data?.resumen_global?.porcentaje_ocupacion || 0;

  return (
    <>
      <style>
        {`
          .dh-maintenance-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
            padding: 2rem 0;
          }
          
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
            margin-bottom: 2rem;
          }
          
          .dh-card-header {
            border-radius: 20px 20px 0 0;
            padding: 1.2rem 1.5rem;
            border: none;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-weight: 700;
          }
          
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            border-radius: 10px;
            padding: 0.6rem 1.5rem;
            font-weight: 600;
            color: white;
            transition: all 0.3s;
          }
          
          .btn-dh-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(17, 153, 142, 0.4);
            color: white;
          }
        `}
      </style>

      <div className="dh-maintenance-bg">
        <ToastContainer />

        <div className="dh-main-header">
          <Container>
            <Row className="align-items-center">
              <Col>
                <Button
                  variant="link"
                  onClick={() => navigate(-1)}
                  className="text-white p-0 mb-2"
                  style={{ textDecoration: "none" }}
                >
                  <FaArrowLeft /> Volver
                </Button>
                <h1 className="dh-main-title d-flex align-items-center">
                  <FaHotel className="me-2" />
                  Estado del Campamento
                </h1>
                <p className="dh-main-subtitle mb-0">
                  Vista general de la ocupabilidad por módulo (camas ocupadas, reservadas y libres).
                </p>
              </Col>
              <Col xs="auto" className="d-flex align-items-center">
                <Button
                  onClick={loadEstado}
                  disabled={estado.loading}
                  className="btn-dh-primary"
                >
                  <FaSync className={estado.loading ? "me-2 fa-spin" : "me-2"} />
                  {estado.loading ? "Actualizando..." : "Actualizar"}
                </Button>
              </Col>
            </Row>
          </Container>
        </div>

        <Container>
          <Row className="mb-4">
            <Col md={12}>
              <Card className="dh-card">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <FaBed className="me-2 text-primary" size={24} />
                    <strong style={{ fontSize: "1.1rem" }}>Resumen Global</strong>
                  </div>
                  <p className="text-muted small mb-3 d-flex align-items-center">
                    <FaInfoCircle className="me-1" />
                    Los datos corresponden al proyecto seleccionado en la barra superior.
                  </p>
                  
                  <Row>
                    <Col md={3}>
                      <h6 className="text-muted mb-2">Total de Camas</h6>
                      <h3 className="mb-0">{totalCamas}</h3>
                    </Col>
                    <Col md={2}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <h6 className="text-muted mb-2">Ocupadas</h6>
                          <h3 className="mb-0">
                            <Badge bg="danger">{totalOcupadas}</Badge>
                          </h3>
                        </div>
                        <Button
                          variant="link"
                          size="sm"
                          onClick={descargarReporteOcupadas}
                          disabled={descargando.ocupadas || totalOcupadas === 0}
                          title="Descargar detalle de camas ocupadas"
                          className="p-0"
                        >
                          {descargando.ocupadas ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <FaDownload size={18} className="text-danger" />
                          )}
                        </Button>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <h6 className="text-muted mb-2">Reservadas</h6>
                          <h3 className="mb-0">
                            <Badge bg="warning" text="dark">{totalReservadas}</Badge>
                          </h3>
                        </div>
                        <Button
                          variant="link"
                          size="sm"
                          onClick={descargarReporteReservadas}
                          disabled={descargando.reservadas || totalReservadas === 0}
                          title="Descargar detalle de camas reservadas"
                          className="p-0"
                        >
                          {descargando.reservadas ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <FaDownload size={18} className="text-warning" />
                          )}
                        </Button>
                      </div>
                    </Col>
                    <Col md={2}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <h6 className="text-muted mb-2">Libres</h6>
                          <h3 className="mb-0">
                            <Badge bg="success">{totalLibres}</Badge>
                          </h3>
                        </div>
                        <Button
                          variant="link"
                          size="sm"
                          onClick={descargarReporteLibres}
                          disabled={descargando.libres || totalLibres === 0}
                          title="Descargar detalle de camas libres"
                          className="p-0"
                        >
                          {descargando.libres ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <FaDownload size={18} className="text-success" />
                          )}
                        </Button>
                      </div>
                    </Col>
                    <Col md={3}>
                      <h6 className="text-muted mb-2">No Disponibles</h6>
                      <h3 className="mb-0">
                        <Badge bg="secondary">{totalNoDisponibles}</Badge>
                      </h3>
                    </Col>
                  </Row>
                  
                  <div className="mt-4">
                    <small className="text-muted">
                      Ocupación global: {porcentajeOcupacionGlobal.toFixed(2)}%
                    </small>
                    <ProgressBar
                      now={porcentajeOcupacionGlobal}
                      label={`${porcentajeOcupacionGlobal.toFixed(2)}%`}
                      className="mt-1"
                      variant={porcentajeOcupacionGlobal > 80 ? "danger" : porcentajeOcupacionGlobal > 50 ? "warning" : "success"}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card className="dh-card">
                <Card.Header className="dh-card-header d-flex justify-content-between align-items-center">
                  <span>
                    <FaBed className="me-2" />
                    Detalle por Zona
                  </span>
                </Card.Header>
                <Card.Body>
                  {!estado.data?.zonas || estado.data.zonas.length === 0 ? (
                    <Alert variant="info">
                      No hay información de zonas para el proyecto seleccionado.
                    </Alert>
                  ) : (
                    <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                      <Table striped hover size="sm" responsive>
                        <thead>
                          <tr>
                            <th>Zona</th>
                            <th className="text-end">Total</th>
                            <th className="text-end">Ocupadas</th>
                            <th className="text-end">Reservadas</th>
                            <th className="text-end">Libres</th>
                            <th className="text-end">No Disponibles</th>
                            <th className="text-center">Ocupación</th>
                          </tr>
                        </thead>
                        <tbody>
                          {estado.data.zonas.map((zona) => {
                            const total = zona.total_camas || 0;
                            const ocupadas = zona.camas_ocupadas || 0;
                            const reservadas = zona.camas_reservadas || 0;
                            const libres = zona.camas_libres || 0;
                            const noDisponibles = zona.camas_no_disponibles || 0;
                            const porcentaje = zona.porcentaje_ocupacion || 0;

                            return (
                              <tr key={zona.zona_id}>
                                <td>
                                  <strong>{zona.zona_nombre}</strong>
                                </td>
                                <td className="text-end"><strong>{total}</strong></td>
                                <td className="text-end">
                                  <Badge bg="danger">{ocupadas}</Badge>
                                </td>
                                <td className="text-end">
                                  <Badge bg="warning" text="dark">
                                    {reservadas}
                                  </Badge>
                                </td>
                                <td className="text-end">
                                  <Badge bg="success">{libres}</Badge>
                                </td>
                                <td className="text-end">
                                  <Badge bg="secondary">{noDisponibles}</Badge>
                                </td>
                                <td style={{ minWidth: 180 }}>
                                  <ProgressBar
                                    now={porcentaje}
                                    variant={
                                      porcentaje > 80
                                        ? "danger"
                                        : porcentaje > 50
                                        ? "warning"
                                        : "success"
                                    }
                                    label={`${porcentaje.toFixed(2)}%`}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default EstadoCampamento;

